var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M15.23 1.875h2.757l-6.022 6.883 7.085 9.367h-5.548l-4.345-5.68-4.971 5.68H1.427l6.442-7.363-6.797-8.887h5.689l3.927 5.192 4.543-5.192Zm-.967 14.6h1.528L5.93 3.438H4.29l9.972 13.037Z",
    fill: "currentColor"
  })));
};
export default SvgTwitter;